var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.9995C25.6569 26.9995 27 25.6558 27 23.9995C27 22.3433 25.6569 20.9995 24 20.9995C22.3432 20.9995 21 22.3433 21 23.9995C21 25.6558 22.3432 26.9995 24 26.9995Z",
    fill: "url(#paint0_linear_3708_7083)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8122 19.3589C17.5732 10.8804 30.4269 10.8804 37.1879 19.3589L39.3062 22.0151C40.2314 23.1753 40.2314 24.8237 39.3062 25.9839L37.1879 28.6401C30.4269 37.1187 17.5732 37.1187 10.8122 28.6401L8.69388 25.9839C7.76871 24.8237 7.76871 23.1753 8.69388 22.0151L10.8122 19.3589ZM30 23.9995C30 27.314 27.3138 29.9995 24 29.9995C20.6863 29.9995 18 27.314 18 23.9995C18 20.6851 20.6863 17.9995 24 17.9995C27.3138 17.9995 30 20.6851 30 23.9995Z",
    fill: "url(#paint1_linear_3708_7083)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_7083",
    x1: 8,
    y1: 13,
    x2: 27.6759,
    y2: 43.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3708_7083",
    x1: 8,
    y1: 13,
    x2: 27.6759,
    y2: 43.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGray);
export default __webpack_public_path__ + "static/media/EyeGray.7fafea79b38760046e699da01c657b30.svg";
export { ForwardRef as ReactComponent };